import { HttpErrorResponse } from '@angular/common/http'
import { ErrorMessage } from 'src/app/services/ui.service'

export class BaseError implements ErrorMessage {
  constructor(
    public message: string,
    public detailedMessage: string
  ) {}
}

export class HttpError extends BaseError {
  constructor(
    public responseCode: number,
    message: string,
    public url: string,
    public body: Object
  ) {
    // Use only the body message for user-facing display — never expose API URLs or HTTP internals
    const bodyMessage = body && 'message' in body ? String(body['message']) : null
    super(message, bodyMessage || message)
  }
}

export class Http401Error extends HttpError {
  constructor(message: string, url: string, body: Object) {
    super(401, message, url, body)
  }
}

export class Http403Error extends HttpError {
  constructor(message: string, url: string, body: Object) {
    super(403, message, url, body)
  }
}

export class Http404Error extends HttpError {
  constructor(message: string, url: string, body: Object) {
    super(404, message, url, body)
  }
}

export class Http409Error extends HttpError {
  constructor(message: string, url: string, body: Object) {
    super(409, message, url, body)
  }
}

export function convertHttpErrorResponse(httpErrorResponse: HttpErrorResponse, url: string) {
  if (httpErrorResponse.error instanceof ErrorEvent) {
    // Don't expose the API URL in user-facing messages
    return new BaseError('A network error occurred. Please try again.', 'A network error occurred. Please try again.')
  }

  // The error is an actual HTTP error
  switch (httpErrorResponse.status) {
    case 401:
      return new Http401Error(httpErrorResponse.message, url, httpErrorResponse.error)
    case 403:
      return new Http403Error(httpErrorResponse.message, url, httpErrorResponse.error)
    case 404:
      return new Http404Error(httpErrorResponse.message, url, httpErrorResponse.error)
    case 409:
      return new Http409Error(httpErrorResponse.message, url, httpErrorResponse.error)
  }
  return new HttpError(httpErrorResponse.status, httpErrorResponse.message, url, httpErrorResponse.error)
}
